<app-menu [logged]=hasToken()></app-menu>

<div class="container-fluid">
  <div class="row">
    <div class="offset-sm-1 col-sm-10">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<app-footer></app-footer>